import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { deleteDialogData } from '../../../page/templates/templates.component';
@Component({
  selector: 'app-delete-template-dialog',
  templateUrl: './delete-template-dialog.component.html',
  styleUrls: ['./delete-template-dialog.component.scss'],
  standalone: false,  // NOSONAR
})
export class DeleteTemplateDialogComponent implements OnInit {
  id;
  template_name;
  constructor(public dialogRef: MatDialogRef<DeleteTemplateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dataStore: deleteDialogData) { }
  ngOnInit(): void {
    this.template_name = this.dataStore.template_name;
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  close(): void {
    this.dialogRef.close();
  }
  public saveClick() {
    this.id = this.dataStore.template_id;
    this.dialogRef.close({ data: this.id });
  }
}